
export const APPEAL_KIND = ['payin', 'payout'];

